import { mergeMap, withLatestFrom } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { IGetSelectorStateType } from '@cbridge-utils/reselect';
import { NodeAction, selectedNodeSelector } from '@cbridge-packages/node';
import { RouterAction, withSkipUnsavedChangesConfirmation } from '@cbridge-packages/routing';
import { RouteSegments } from '@cbridge-packages/routing-client-admin';

type IState = IGetSelectorStateType<typeof selectedNodeSelector>;

const STREAMS_ROOT_PATH = `/${RouteSegments.Root.Config}/${RouteSegments.Settings.Streams}`;

export const redirectOnSelectedNodeRemovedEpic: IEpic<IState> = (action$, state$) => action$.pipe(
  isTypeOfAndGetPayload(NodeAction.remove.done),
  withLatestFrom(state$),
  mergeMap(([payload, state]) => {
    const { nodeId } = payload.result;
    const selectedNode = selectedNodeSelector(state);

    if (selectedNode !== nodeId) {
      return [];
    }

    return [
      RouterAction.replace([STREAMS_ROOT_PATH, withSkipUnsavedChangesConfirmation()]),
    ];
  }),
);
